import React from 'react';
import { heroPropTypes } from './HeroPropTypes';
import Picture from '@Theme/natucare/components/Picture/Picture';
import * as styles from './Hero.module.scss';
const Hero = _ref => {
  let {
    actions,
    picture
  } = _ref;
  if (!picture) {
    return false;
  }
  return /*#__PURE__*/React.createElement("section", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("a", {
    className: styles.rootLink,
    href: actions.picture.href
  }, picture && picture.xs && /*#__PURE__*/React.createElement(Picture, {
    xs: picture.xs,
    sm: picture === null || picture === void 0 ? void 0 : picture.sm,
    md: picture === null || picture === void 0 ? void 0 : picture.md,
    lg: picture === null || picture === void 0 ? void 0 : picture.lg,
    pictureClassname: styles.rootPicture,
    imgClassname: styles.rootImage,
    alt: picture === null || picture === void 0 ? void 0 : picture.alt
  })));
};
export default Hero;